let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5N8v4")).then(() => parcelRequire('buotH'));